import { LeadCandidate } from "@inrange/building-manager-api-client";

// Where a search result sits in the review cycle.
//
// Two surfaces show this - the results table's Status cell and the edit panel's
// pinned header - and an operator sees them side by side, so a second copy of
// either the precedence or the labels would read as a bug the moment they
// diverged. Shared from here rather than mirrored (the lead-pipeline "surfaces
// that must agree" rule); `StatusBadge.tsx` renders it.
//
// "Viewed" rather than "Reviewed": the stamp now fires when the operator OPENS
// a row, so the status answers "have I looked at this one?" - which is what
// makes a saved search resumable across sessions.
export type CandStatus = "new" | "reviewed" | "rejected" | "alreadyLead";

// Some panel call sites carry no search-result status at all (the leads inbox
// renders promoted leads, not candidates). An explicit member says so at the
// call site rather than leaning on an optional prop's implicit default.
export type PanelReviewStatus = CandStatus | "no-status";

// Precedence, most decided first: promotion outranks a rejection, and a
// rejection outranks having been looked at. So stamping Viewed on open can
// never change what a rejected or promoted row displays.
export const candidateStatus = (c: LeadCandidate): CandStatus => {
  if (c.existingLeadId) return "alreadyLead";
  if (c.rejectedAt) return "rejected";
  if (c.reviewedAt) return "reviewed";
  return "new";
};

export const CAND_STATUS_META: Record<
  CandStatus,
  { label: string; bg: string; text?: "dark" }
> = {
  new: { label: "New", bg: "secondary" },
  reviewed: { label: "Viewed", bg: "info" },
  rejected: { label: "Rejected", bg: "dark" },
  alreadyLead: { label: "Lead", bg: "warning", text: "dark" },
};
